(() => {
  if (!customElements.get('nwg-size-guide')) {
    customElements.define('nwg-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.ready = () => this.connectGuide();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, {once:true});
        else this.connectGuide();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.ready);
      }
      connectGuide() {
        const section = this.closest('.shopify-section');
        const description = section?.querySelector('.product-block__description');
        const link = this.querySelector('a');
        if (!description || !link) return;
        const headings = [...description.querySelectorAll('h2,h3,h4')];
        const heading = headings.find(node => {
          const title = node.textContent.toLowerCase().replace(/[^a-zäöüß]/g, '');
          if (!['fitadvice','größenberatung','grössenberatung','sizeguide','sizechart','sizetable','sizing','sizefit','fitsize','passform','größeundpassform','grösseundpassform'].some(name => title.includes(name))) return false;
          let next = node.nextElementSibling;
          while (next && !/^H[1-6]$/.test(next.tagName)) {
            if (next.matches('table') || next.querySelector('table')) return true;
            next = next.nextElementSibling;
          }
          return false;
        });
        if (!heading) return;
        if (!heading.id) heading.id = 'nwg-size-guide-' + this.dataset.section;
        heading.classList.add('nwg-size-guide-target');
        link.href = '#' + heading.id;
        link.hidden = false;
      }
    });
  }
  if (document.documentElement.hasAttribute('data-nwg-size-ux')) return;
  document.documentElement.setAttribute('data-nwg-size-ux', '');
  document.addEventListener('click', event => {
    const link = event.target.closest('.nwg-size-guide-link, [data-nwg-change-size]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    for (let parent = target.parentElement; parent; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS') parent.open = true;
    }
    const field = link.hasAttribute('data-nwg-change-size') ? target.querySelector('input:checked, select, input') : target;
    if (field) {
      if (field === target) field.setAttribute('tabindex','-1');
      field.focus({preventScroll:true});
    }
    target.scrollIntoView({block:'start',behavior:'instant'});
  });
})();
